import { useStore } from "~/store";

export function useSchemaOrg(notaria: any) {
  const store = useStore();
  
  if (!notaria || !notaria.Contacto) return;

  // Enhance AEO (Answer Engine Optimization) by exposing all services offered
  const offeredServices = [];
  if (notaria.Servicios && Array.isArray(notaria.Servicios)) {
    notaria.Servicios.filter((s: any) => s.Publicado).forEach((s: any) => {
      offeredServices.push({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": s.Titulo,
          "description": s.Subtitulo || s.Resumen || s.Titulo,
          "url": `https://${store.host}/servicios/${s.Slug}`
        }
      });
    });
  }

  // Extract Team Members for AEO
  const teamMembers = [];
  if (notaria.Team && Array.isArray(notaria.Team)) {
    notaria.Team.forEach((t: any) => {
      if (t.Nombre) {
        teamMembers.push({
          "@type": "Person",
          "name": t.Nombre,
          "jobTitle": t.Puesto || undefined,
          "email": t.Email || undefined,
          "telephone": t.Extension || undefined
        });
      }
    });
  }

  // Extract Principal Notaries
  if (notaria.Notarios && Array.isArray(notaria.Notarios)) {
    notaria.Notarios.forEach((n: any) => {
      if (n.Nombre) {
        teamMembers.push({
          "@type": "Person",
          "name": n.Nombre,
          "jobTitle": "Notario",
          "email": n.Email || undefined,
          "url": n.Web || undefined
        });
      }
    });
  }

  const schemaData: any = {
    "@context": "https://schema.org",
    "@type": ["Notary", "LegalService", "LocalBusiness"],
    "name": notaria.Nombre,
    "description": notaria.Theme?.Home?.Description || notaria.Theme?.Home?.Titulo?.Texto || `Servicios notariales en ${notaria.Contacto.Municipio}`,
    "url": `https://${store.host}`,
    "logo": notaria.Theme?.Home?.Banner?.ImagenLogo ? `https://${store.host}/appdata/static/${notaria.Theme.Home.Banner.ImagenLogo}` : undefined,
    "image": notaria.Theme?.Home?.Banner?.Imagen ? `https://${store.host}/appdata/static/${notaria.Theme.Home.Banner.Imagen}` : undefined,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": notaria.Contacto.Direccion,
      "addressLocality": notaria.Contacto.Municipio,
      "addressRegion": notaria.Contacto.Provincia,
      "postalCode": notaria.Contacto.CP,
      "addressCountry": "ES"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": notaria.Contacto.Coordinates?.lat,
      "longitude": notaria.Contacto.Coordinates?.lng
    },
    "telephone": notaria.Contacto.Telefono || notaria.Contacto.Movil,
    "email": notaria.Contacto.Email,
    "openingHours": notaria.Contacto.Horario ? notaria.Contacto.Horario.replace(/(?:\r\n|\r|\n)/g, " ").substring(0, 100) : undefined,
    "hasMap": notaria.Contacto.EnlaceMaps || undefined,
    "sameAs": [
      notaria.Contacto.Facebook,
      notaria.Contacto.LinkedIn,
      notaria.Contacto.Twitter,
      notaria.Contacto.Instagram
    ].filter(Boolean)
  };

  if (offeredServices.length > 0) {
    schemaData.makesOffer = offeredServices;
  }

  if (teamMembers.length > 0) {
    schemaData.employee = teamMembers;
  }

  useHead({
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(schemaData)
      }
    ]
  });
}
